import PropTypes from "prop-types";
import { Row, Col } from "reactstrap";
import { useEffect, useState } from "react";
import { toast } from "../../../../core/helpers/message-helper";
import FormModal from "../../../../core/ui/components/FormModal";
import InputController from "../../../../core/ui/components/InputController";
import SelectController from "../../../../core/ui/components/SelectController";
import { useForm } from "react-hook-form";
import { crearOEditarArea } from "../../services/areas-service";
import { obtenerParametrosPorTipos } from "../../../Parametros/services/parametros-service";

const REQUIRED_RULE = {
    required: "Este campo es requerido",
};

const YES_OR_NO_OPTIONS = [
    { label: "SI", value: 1 },
    { label: "NO", value: 0 },
];

const FormArea = ({ modalState, onSave }) => {
    const { area } = modalState.data;
    const [tiposProcesos, setTiposProcesos] = useState([]);

    useEffect(async () => {
        const resp = await obtenerParametrosPorTipos("tipos_procesos");
        if (!resp.status) return toast.error(resp.message);

        const tiposProcesos = resp.data.map((tipoProceso) => {
            return {
                value: tipoProceso.id,
                label: tipoProceso.nombre,
            };
        });

        setTiposProcesos(tiposProcesos);
    }, []);

    const vista = {
        label: area.vista == 1 ? "SI" : "NO",
        value: area.vista == 1 ? 1 : 0,
    };

    const defaultValues = {
        id: area.id == null ? "" : area.id,
        nombre: area.nombre != null ? area.nombre : "",
        tipo_proceso_id: area.tipo_proceso_id
            ? {
                  label: area.nombre_tipo_proceso,
                  value: area.tipo_proceso_id,
              }
            : "",
        vista: vista,
        color: area.color != null ? area.color : "#000000",
        img: "",
        email: area.email != null ? area.email : "",
        descripcion: area.descripcion != null ? area.descripcion : "",
    };

    const form = useForm({ defaultValues });
    useEffect(() => form.reset(defaultValues), [area]);

    const onCreateArea = async () => {
        const formData = new FormData(document.getElementById("formAreas"));
        const resp = await crearOEditarArea(formData);
        if (!resp.status) return toast.error(resp.message);

        toast.success(resp.message);
        modalState.close();
        onSave();
    };

    return (
        <FormModal
            size="lg"
            form={form}
            id="formAreas"
            onSubmit={onCreateArea}
            isOpen={modalState.show}
            headerTitle={modalState.title}
            closeModal={() => modalState.set({ show: false })}
        >
            <Row>
                <InputController
                    type="hidden"
                    name="id"
                    errors={form.formState.errors}
                    control={form.control}
                />
                <Col sm={12}>
                    <InputController
                        label="Nombre"
                        errors={form.formState.errors}
                        control={form.control}
                        name="nombre"
                        rules={REQUIRED_RULE}
                        placeholder="Nombre del area"
                    />
                </Col>
                <Col sm={5}>
                    <SelectController
                        label="Tipo Proceso"
                        options={tiposProcesos}
                        errors={form.formState.errors}
                        control={form.control}
                        name="tipo_proceso_id"
                        rules={REQUIRED_RULE}
                        placeholder="Tipo de proceso"
                    />
                </Col>
                <Col sm={4}>
                    <SelectController
                        errors={form.formState.errors}
                        control={form.control}
                        name="vista"
                        label="Vista area"
                        rules={REQUIRED_RULE}
                        options={YES_OR_NO_OPTIONS}
                    />
                </Col>
                <Col sm={3}>
                    <InputController
                        type="color"
                        label="Color"
                        errors={form.formState.errors}
                        control={form.control}
                        name="color"
                        rules={REQUIRED_RULE}
                    />
                </Col>
                <Col sm={5}>
                    <InputController
                        id="img"
                        name="img"
                        type="file"
                        errors={form.formState.errors}
                        label="Imágen"
                        control={form.control}
                        placeholder="Imágen"
                        rules={area.id == null ? REQUIRED_RULE : {}}
                    />
                </Col>
                <Col sm={7}>
                    <InputController
                        label="Email"
                        errors={form.formState.errors}
                        control={form.control}
                        name="email"
                        rules={REQUIRED_RULE}
                        placeholder="Correo electronico"
                    />
                </Col>
                <Col sm={12}>
                    <InputController
                        type="textarea"
                        label="Descripción"
                        errors={form.formState.errors}
                        control={form.control}
                        name="descripcion"
                        rules={REQUIRED_RULE}
                        placeholder="Descripción"
                    />
                </Col>
            </Row>
        </FormModal>
    );
};

FormArea.propTypes = {
    modalState: PropTypes.object,
    onSave: PropTypes.func,
};

export default FormArea;
